import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyStateHeading: {
		id: 'business-list.list-view.empty-state.empty-state-heading',
		defaultMessage: 'View your work in a list',
		description: 'Heading of the list empty state',
	},
	emptyStateDescription: {
		id: 'business-list.list-view.empty-state.empty-state-description',
		defaultMessage:
			'Manage and sort all your project’s work into a single list that can be easily scanned and sorted by category.',
		description: 'Message describing what can be done in the list view',
	},
	createItemButton: {
		id: 'business-list.list-view.empty-state.create-item-button',
		defaultMessage: 'Create an item',
		description: 'Button message for user to create a new list item',
	},
	createItemButtonIssueTermRefresh: {
		id: 'business-list.list-view.empty-state.create-item-button-issue-term-refresh',
		defaultMessage: 'Create a work item',
		description: 'Button message for user to create a new list item',
	},
	createIssueButton: {
		id: 'business-list.list-view.empty-state.create-issue-button',
		defaultMessage: 'Create issue',
		description: 'Button message for user to create a new list item',
	},
	createIssueButtonIssueTermRefresh: {
		id: 'business-list.list-view.empty-state.create-issue-button-issue-term-refresh',
		defaultMessage: 'Create work item',
		description: 'Button message for user to create a new list item',
	},
});
